import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Roadmap() {
  return <div>ShuffleMint Beta ShuffleMint Delta ShuffleMint Omega</div>;
}

export default Roadmap;
